import { Icon, ProjectLinkButton, SectionSubTitle } from '../../../globalStyles'
import { blogsData } from '../../../data/blogsData'
import {
  BlogList,
  BlogDiv,
  ProjectsAndBlogsContainer,
  BlogImage,
  BlogTitle,
  BlogTags
} from '../MyWorkSection.elements'
import liveBtnIcon from '../../../assets/button-icons/liveBtnIcon.svg'
import { Fragment } from 'react'
const Blogs = () => {
  return (
    <ProjectsAndBlogsContainer>
      <SectionSubTitle>
        <h5>Blogs</h5>
      </SectionSubTitle>

      <BlogList>
        {blogsData.map((blog) => (
          <BlogItem
            title={blog?.title}
            key={blog.id}
            image={blog?.image}
            tags={blog?.tags}
            link={blog?.link}
          />
        ))}
      </BlogList>
    </ProjectsAndBlogsContainer>
  )
}
export default Blogs

const BlogItem = ({ title, image, tags, link }) => {
  return (
    <BlogDiv>
      <BlogImage>
        <img src={image} alt="" />
      </BlogImage>
      <BlogTitle>{title}</BlogTitle>
      <BlogTags>
        <strong>Tags: {'  '}</strong>
        {tags.map((tag, i) => (
          <Fragment key={i}>
            <span>{tag}.</span>
            {'   '}
          </Fragment>
        ))}
      </BlogTags>
      <ProjectLinkButton onClick={() => window.open(link)} blogBtn>
        <Icon src={liveBtnIcon} alt="liveIcon" blogBtn />
        <strong style={{ letterSpacing: '2px' }}>READ</strong>
      </ProjectLinkButton>
    </BlogDiv>
  )
}
